import { Client } from "../../clients/client";
import { ShippopCreateCodForm } from "./forms/ShippopCreateCodForm";

export class ShippopUseCase {
  constructor(private client: Client) {}

  async createCodShippop(form: ShippopCreateCodForm) {
    return this.client.shippop.postShippopCod({ email: form.email });
  }
}
